module.exports = __webpack_public_path__ + "img/banner08m.6f5aa301.png";